
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/traffic-tickets",
      function () {
        return require("private-next-pages/traffic-tickets/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/traffic-tickets"])
      });
    }
  